import type { SelectedAsset } from '@onramp/state/BuyWidgetState';
import { atom } from 'jotai';

export const isLoadingTransferAtom = atom<boolean>(false);

export const assetToSelectAtom = atom<SelectedAsset | undefined>(undefined);
export const createTransferErrorAtom = atom<string | undefined>(undefined);
